import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-infinity-icon',
  standalone: true,
  templateUrl: './infinity-icon.component.html',
  styleUrls: ['./infinity-icon.component.scss']
})
export class InfinityIconComponent {
  @Input() width: number | string = 17;
  @Input() height: number | string = 8;
}
